import { ArticlesApiFactory, DisciplinesApiFactory } from './znaniya-client';

const apiHost = process.env.NEXT_PUBLIC_API_HOST;

export const disciplinesClientApi = DisciplinesApiFactory({}, apiHost);
export const articlesClientApi = ArticlesApiFactory({}, apiHost);
